import Button from '@/Components/Button/Button';
import MultiSelect from '@/Components/MultiSelect/MultiSelect';
import type NewWordsStore from '@/Stores/NewWords/NewWordsStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Styles from './NewWordsFilterPanel.module.scss';
import NewWordsOnKeyDownInputSearch from './NewWordsOnKeyDownInputSearch';

const NewWordsFilterPanel = observer(({ store }: { store: NewWordsStore }): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <div className={Styles.container}>
            <div className={Styles.multiselects}>
                <div className={Styles.multiselect}>
                    {
                        store.state.currentUserIsAdmin && (
                            <MultiSelect
                                options={store.state.users}
                                selected={store.state.chosenUsers}
                                onChange={store.setChosenUsers}
                                title={t('Users')}
                                useContains
                            />
                        )
                    }
                </div>
                <div className={Styles.multiselect}>
                    <MultiSelect
                        options={store.state.languages}
                        selected={store.state.chosenLanguages}
                        onChange={store.setChosenLanguages}
                        title={t('Languages')}
                        useContains
                    />
                </div>
            </div>

            <NewWordsOnKeyDownInputSearch store={store} />
            <Button onClick={(_) => store.reload()}>{t('Search')}</Button>
        </div>
    );
});

export default NewWordsFilterPanel;
